var map = {
	"./activity.js": "3a03",
	"./configuration.js": "08b9",
	"./package.js": "2358",
	"./project.js": "42ff",
	"./quotations.js": "50fd",
	"./shop.js": "c46f",
	"./star.js": "b6fc",
	"./tips.js": "8644",
	"./upload.js": "6510",
	"./user.js": "d969"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9990";